'use client';

import { useRef, useState } from 'react';

export function useClaimDebounce<T>(action: () => Promise<T>) {
  const [loading, setLoading] = useState(false);
  const lockRef = useRef(false);

  const run = async () => {
    if (lockRef.current) {
      return;
    }

    lockRef.current = true;
    setLoading(true);

    try {
      return await action();
    } finally {
      lockRef.current = false;
      setLoading(false);
    }
  };

  return {
    loading,
    run,
  };
}
